








import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { OperationsMixin } from '@/main/mixins/operations';
import { store } from '@/modules/servis/zakazka/store/edit';
import { EditMixin } from '../../mixins/editMixin';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import { apiProvider } from '../../api';


export default mixins(PageModeMixin, EditMixin, OperationsMixin).extend({
	name: 'HlavniKarta',
	components: {
		ProvozovnaSelect,
	},
	props: {
		storeUri: {
			type: String,
			required: true,
		},
	},
	computed: {
		...genVuexComputeds(store),
		isCreateOrEditMode(): boolean {
			return this.isEditMode;
		},
		
	},
	
	watch: {
		ProvozovnaId: {
			immediate: true,
			async handler(value, oldVal) {
				if (value && oldVal) {
					const { data: warehouseData } = await apiProvider.getWarehouseByWorkshopId(value);
					this.dropdownList.Warehouse = warehouseData;
				}
			},
		},
		WarehouseId: {
			immediate: true,
			async handler(value, oldVal) {
				if (value) {
					const { data } = await apiProvider.GetTargetWarehouseByWorkshopAndWarehouseId(this.ProvozovnaId, value);
					this.dropdownList.SkladOzn = data;
				}
			},
		},
	},
});
